import React, { Component } from "react";
import Button from "../Button";
import Col from "../Col";
import Form from "../Form";
import Input from "../Input";
import Row from "../Row";
import SuiteAreas from "./SuiteAreas";
import {
  setSuiteFormData,
  clearSuiteFormData,
} from "../../store/actions/suiteForm";
import {
  fetchSuiteAreas,
  fetchPropertySuites,
  fetchSuiteCounts,
} from "../../store/actions/suites";

import {
  selectHomeOwners,
  selectContacts,
} from "../../store/selectors/contacts";
import { selectSuiteFormData } from "../../store/selectors/suiteForm";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { selectSuiteAreas } from "../../store/selectors/suiteAreas";
import File from "../File";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { selectValidation } from "../../store/selectors/Validation";
import { clearValidation } from "../../store/actions/assets";
import { fetchAssetsBySuiteId } from "../../store/actions/assets";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import { stopFormLoading } from "../../store/actions/loader";

import Loader from "../Loader";
import { selectSuites } from "../../store/selectors/suites";
import Select from "../Select";
import Picker from "../Picker";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { getBuildingLevels } from "../../store/actions/buildings";
import { getSuiteStatuses } from "../../store/actions/SuiteStatus";
import CreatableSelect from "react-select/creatable";
import * as client from "../../services/client";

import { variables } from "../../Tenants";
import { checkSparkDataAvailable, serviceRequestTableLocalTime } from "../../helpers/validationHelper";
import TextEditor from "../Editor/Editor";
import { onUrlImageExtensionExist,onCheckExtensionDocument, generateRandomNumber } from "../../helpers/CommonHelpers";
import OtherDetails from "./OtherDetails";
import { upload } from '../../helpers/uploadDocument';
import moment from 'moment';


class SuiteForm extends Component {
  constructor(props) {
    super(props);
    if (this.props.suiteFormData.id && this.props.suiteFormData.keyFobs !== null) {
      this.props.onSetSuiteFormData({
        keyFobs: this.props.suiteFormData.keyFobs.map(item => {
          return {
            ...item,
            label: item.name,
            value: item.name
          }
        })
      })
    }

    this.state = {
      areas: [],
      errors: {},
      buttonPressed: "",
      show: false,
      value: 1,
      suiteAreas: this.props.suiteAreas,
      floorImage:
        this.props.suiteFormData && this.props.suiteFormData.floorPlanURL
          ? this.props.suiteFormData.floorPlanURL
          : null,
      loading: false,
      editorState: props.suiteFormData.keyHandOffInstructions ? props.suiteFormData.keyHandOffInstructions : ""

    };
  }

  onEditorChange = (editorState) => {
    this.setState({
      editorState
    }, () => {
      this.props.onSetSuiteFormData({
        keyHandOffInstructions: editorState
      });
    });
  };

  componentDidMount() {
    const { user, getBuildingLevels, onSetSuiteFormData, suiteFormData, getSuiteStatuses } =
      this.props;
      this.onAddPair();
    if (this.props.suiteFormData.propertyId) {
      this.props.onFetchPropertySuites(
        this.props.suiteFormData.propertyId,
        user.id,
        user.roles[0].role.name,
        false
      );
    }
    this.props.onStopFormLoading();
    this.props.fetchSuiteAreas();
    getSuiteStatuses();
    this.setState({ suiteAreas: this.props.suiteAreas });
    if (this.props.suiteFormData.id) {
      let suiteParkingSlots = this.props.suiteFormData.parkingStalls;
      let suiteStorageLockers = this.props.suiteFormData.storageLockers;
      let suiteKeyFobs = this.props.suiteFormData.keyFobs;
      let parkingStalls = [];
      let storageLockers = [];
      let keyFobs = [];

      if (suiteParkingSlots && suiteParkingSlots.length > 0) {
        suiteParkingSlots.map((ps) => {
          let obj = {
            label: ps.name,
            value: ps.name,
          };
          parkingStalls = [...parkingStalls, obj];
        });
      }
      if (suiteStorageLockers && suiteStorageLockers.length > 0) {
        suiteStorageLockers.map((ps) => {
          let obj = {
            label: ps.name,
            value: ps.name,
          };
          storageLockers = [...storageLockers, obj];
        });
      }
      if (suiteKeyFobs && suiteKeyFobs.length > 0) {
        suiteKeyFobs.map((kf) => {
          let obj = {
            label: kf.name,
            value: kf.name,
          };
          keyFobs = [...keyFobs, obj];
        });
      }
      onSetSuiteFormData({
        parkingStalls: parkingStalls,
        storageLockers: storageLockers,
        keyFobs: keyFobs
      });
      let areasData = this.state.areas;
      let suiteAreas = this.props.suiteAreas;
      let data = this.props.suiteFormData.areas;
      data.map((item, i) => {
        let object = {
          id: item.areaId,
          customLabel: item.customLabel,
          name: item.name,
        };
        areasData.push(object);
      });

      let areaData = areasData;

      for (var i = 0; i < suiteAreas.length; i++) {
        areaData = areaData.filter((a) => a.id !== suiteAreas[i].id);
      }
      areaData = areaData.map((a) => ({
        id: a.id,
        type: "Other",
        customLabel: a.customLabel,
      }));
      if (areaData.length > 0) {
        if (this.props.suiteFormData.otherAreas.length > 0) {
          for (var l = 0; l < this.props.suiteFormData.otherAreas.length; l++) {
            areaData = areaData.filter(
              (a) => a.id !== this.props.suiteFormData.otherAreas[l].id
            );
          }
        }
      }

      let otherAreas = [...this.props.suiteFormData.otherAreas, ...areaData];

      otherAreas.map((oItem) => {
        let o = {
          id: oItem.id,
          type: oItem.type,
          customLabel: oItem.name,
        };
        suiteAreas = [...suiteAreas, o];
      });
      this.setState({ areas: areasData, suiteAreas: suiteAreas });
      getBuildingLevels(this.props.suiteFormData.buildingId);
      for (var i = 0; i < this.props.buildingList.length; i++) {
        if (
          this.props.suiteFormData.buildingId === this.props.buildingList[i].id
        ) {
          onSetSuiteFormData({
            Building: this.props.buildingList[i].building,
            BuildingId: this.props.suiteFormData.buildingId,
            buildingName: this.props.buildingList[i].building,
          });
        }
      }
      onSetSuiteFormData({
        BuildingId: this.props.suiteFormData.buildingId,
      });

    }
    else {
      onSetSuiteFormData({
        ...suiteFormData,
        statusId: '00000000-0000-0000-0000-000000000000'
      })
    }
  }

  setFormData(e) {
    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        ...e,
      },
    });
  }

  componentDidUpdate(prevProps) {
    const {
      clearValidation,
      validation,
      onClose,
      clearSuiteFormData,
      levelList,
      onSetSuiteFormData,
    } = this.props;
    if (validation.status === true) {
      if (validation.message === "message") {
        clearValidation();
      } else if (
        validation.message === "Success" &&
        this.state.buttonPressed === "SaveAndClose"
      ) {
        this.setState({ areas: [], show: false });
        onClose();
        clearSuiteFormData();
        clearValidation();
      } else if (
        validation.message === "Success" &&
        this.state.buttonPressed === "SaveAndAdd"
      ) {
        this.setState({ areas: [], show: false });
        clearSuiteFormData();
        clearValidation();
      }
    }
    if (prevProps.levelList.length < levelList.length) {
      if (this.props.suiteFormData.levelId) {
        for (var i = 0; i < this.props.levelList.length; i++) {
          if (this.props.levelList[i].id === this.props.suiteFormData.levelId) {
            onSetSuiteFormData({
              LevelId: this.props.suiteFormData.levelId,
              Level: this.props.levelList[i].level,
              levelName: this.props.levelList[i].level,
            });
          }
        }
      }
    }

    if (
      levelList.length > 0 &&
      !this.props.suiteFormData.LevelId &&
      !this.props.suiteFormData.Level &&
      this.props.suiteFormData.BuildingId
    ) {
      if (this.props.suiteFormData.levelId) {
        for (var i = 0; i < this.props.levelList.length; i++) {
          if (this.props.levelList[i].id === this.props.suiteFormData.levelId) {
            onSetSuiteFormData({
              LevelId: this.props.suiteFormData.levelId,
              Level: this.props.levelList[i].level,
              levelName: this.props.levelList[i].level,
            });
          }
        }
      }
    }
  }
  onSave = (suiteFormData, actionType) => {
    this.setState({ buttonPressed: actionType });
    const { propertySuites } = this.props;
    let areas = this.state.areas.filter((item) => item.other !== "Other");
    let suiteData = propertySuites.find(
      (data) => data.id === suiteFormData.fromUnitId
    );
    let others =
      suiteData && suiteData.otherAreas && suiteData.otherAreas.length > 0
        ? suiteData.otherAreas
        : [];

    if (
      suiteFormData &&
      suiteFormData.copyFormExistingSuite &&
      suiteFormData.copyFormExistingSuite === true
    ) {
      if (others.length > 0) {
        for (var l = 0; l < others.length; l++) {
          for (var m = 0; m < areas.length; m++) {
            if (areas[m].id === others[l].id) {
              areas[m] = {
                type: "Other",
                customLabel: areas[m].customLabel,
              };
            }
          }
        }
      }
    }
    let keyfobs = suiteFormData.keyFobs && suiteFormData.keyFobs.length > 0 ? suiteFormData.keyFobs.map(item => {
      return {
        Name: item.value
      }
    }) : [];
    const suiteKeysAndValues = suiteFormData.suiteKeysAndValues && suiteFormData.suiteKeysAndValues.length > 0 ? suiteFormData.suiteKeysAndValues : [];
    var filtered = suiteKeysAndValues.filter(function (el) {
      return (el.key?.trim() && el.value?.trim());
    });
    const updatedData = filtered.map(({ id, ...rest }) => rest)  
   let formData = { ...suiteFormData, keyFobs: keyfobs, suiteKeysAndValues: updatedData };
   this.props.onSaveSuite(formData, areas, this.state.floorImage);
  };

  handleAreas = (id, value, area) => {
    let areas = this.state.areas;
    let suiteAreas = this.state.suiteAreas;
    let index = areas.findIndex((data) => data.id === id);
    if (index === -1) {
      let object;
      if (area.name === "Other") {
        object = {
          id: id,
          other: area.name,
        };
      } else {
        object = {
          id: id,
          name: area.name,
        };
      }
      areas.push(object);
    } else {
      areas.splice(index, 1);
      if ((value && value.type) || (area && area.type)) {
        let filteredData = suiteAreas.filter((data) => data.id !== id);
        this.setState({ suiteAreas: filteredData });
      }
    }

    this.setState({ areas: areas });
  };

  onAddArea(id) {
    let areas = this.state.areas;
    let suiteAreas = this.state.suiteAreas;
    let data = areas.filter((item) => item.id === id);
    if (data.length > 0) {
      if (data[0] && data[0].customLabel && data[0].customLabel.trim()) {
        let obj = {
          id: (this.state.value++).toString(),
          otherAreaId: id,
          customLabel: data[0].customLabel.trim(),
        };
        suiteAreas = [...suiteAreas, obj];
        obj = { ...obj, type: "Other" };
        areas = [...areas, obj];

        let filtereddata = areas.filter((object) => object.other !== "Other");
        this.setState({ suiteAreas, areas: filtereddata });
      } else {
        let filtereddata = areas.filter((object) => object.other !== "Other");
        this.setState({ suiteAreas, areas: filtereddata });
      }
    }
  }

  onErrorEmpty = (value) => {
    let errors = this.state.errors;
    errors[value] = "";
    errors["floorPlanURL"] = "";
    this.setState({ errors });
  };
  onEnterText = (text, id) => {
    let areas = this.state.areas;
    let index = areas.findIndex((data) => data.id === id);
    if (index !== -1) {
      areas[index].customLabel = text;
    }
    this.setState({ areas: areas });
  };
  async onValidateFile(file) {
    let errors = this.state.errors;
    let path = file[0].path;
    if (file && file.length > 0) {
      if(onUrlImageExtensionExist(path) ) {
        this.props.onSetSuiteFormData({ floorPlanURL: file });
        this.setState({ floorImage: '' })
        errors["floorPlanURL"] = "";
        this.setState({ errors });
      }
      else {
        this.props.onSetSuiteFormData({ floorPlanURL: file });
        this.setState({ floorImage: '' })
        toast.success('Your document upload has started, it may take some time.',{autoClose: 5000,position:'top-center'});
        let newFileName = path.split(/\.(?=[^\.]+$)/)[0] + moment().format('MMDDYYYYhmmss') + '.' + path.split(/\.(?=[^\.]+$)/)[1]        
        let image =  await upload(file[0], newFileName.replace(/ /g,''));
        this.setState({ floorImage: image })
      }  
     
    } else {
      toast.error(
        " 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG or PDF",
        { autoClose: 12000, position: "top-center" }
      );
    }
  }
  getPropertySuites = () => {
    this.setState({ show: true });
  };
  handleSelectedSuite = async (e) => {
    const {
      propertySuites,
      suiteFormData,
      onSetSuiteFormData,
      clearSuiteFormData,
    } = this.props;
    let id = e.target.value;
    let suiteData = propertySuites.find((data) => data.id === id);
    if (suiteData && suiteData.id) {
      await clearSuiteFormData();
      this.setState({
        floorImage: suiteData.floorPlanURL,
      });
      this.onSetAreas(suiteData);
      onSetSuiteFormData({
        copyFormExistingSuite: true,
        fromUnitId: suiteData.id,
        propertyId: suiteData.propertyId,
        number: suiteFormData.number,
        statusId: suiteFormData.statusId,
        stratalot: suiteData && suiteData.stratalot ? suiteData.stratalot : "",
        assetWarrantyDefaultStartDate:
          suiteData && suiteData.assetWarrantyDefaultStartDate
            ? suiteData && suiteData.assetWarrantyDefaultStartDate
            : null,
        floorPlanURL:
          suiteData && suiteData.floorPlanURL ? suiteData.floorPlanURL : null,
      });
      this.onAddPair();
    }
  };

  handleSelectedStatus = async (e) => {
    const { onSetSuiteFormData } = this.props;
    let id = e.target.value;
    onSetSuiteFormData({
      statusId: id
    });

  };
  onSetAreas = (suiteData) => {
    let areasData = [];
    let suiteAreas = this.props.suiteAreas;
    let data = suiteData.areas;
    data.map((item, i) => {
      let object = {
        id: item.areaId,
        customLabel: item.customLabel,
      };
      areasData.push(object);
    });

    let otherAreas = suiteData.otherAreas;

    otherAreas.map((oItem) => {
      let o = {
        id: oItem.id,
        type: oItem.type,
        customLabel: oItem.name,
      };
      suiteAreas = [...suiteAreas, o];
    });
    this.setState({ areas: areasData, suiteAreas: suiteAreas });
  };
  building() {
    const { suiteFormData } = this.props;
    const { isChanged } = this.state;
    if (isChanged) {
      return suiteFormData.building;
    }
  }

  onChangeBuilding = (object) => {
    const { onSetSuiteFormData, getBuildingLevels } = this.props;
    onSetSuiteFormData({
      Building: object.building,
      BuildingId: object.id,
      buildingName: object.building,
    });
    getBuildingLevels(object.id);
    this.setState({ displayBuildingItem: false, isChanged: false });
  };

  onChangeLevel = (object) => {
    const { onSetSuiteFormData } = this.props;
    onSetSuiteFormData({
      LevelId: object.id,
      Level: object.level,
      levelName: object.level,
    });
    this.setState({
      displayLevelItem: false,
      isChanged: false,
      isLevelChanged: false,
    });
  };

  onCheckExistingParkingStallStorageLockers = (newValue, latestValue, type) => {
    const { suiteFormData, onSetSuiteFormData } = this.props;
    if (latestValue && latestValue.option && latestValue.option.value) {
      this.setState({ loading: true });
      client
        .CheckExistingParkingStallStorageLockers(
          suiteFormData.propertyId,
          latestValue.option.value,
          type === "parkingStalls" ? "ParkingStalls" : "StorageLockers"
        )
        .then((response) => {
          this.setState({ loading: false });
          if (response.status === 200) {
            response.json().then((responseJson) => {
              if (responseJson !== true) {
                if (type === "parkingStalls") {
                  onSetSuiteFormData({ parkingStalls: newValue });
                } else {
                  onSetSuiteFormData({ storageLockers: newValue });
                }
              } else {
                if (type === "parkingStalls") {
                  toast.error("This Parking stall is not available.", {
                    autoClose: 12000,
                    position: "top-center",
                  });
                } else {
                  toast.error("This Storage locker is not available.", {
                    autoClose: 12000,
                    position: "top-center",
                  });
                }
              }
            });
          } else {
            toast.error("Some thing went wrong with the slot validation.", {
              autoClose: 12000,
              position: "top-center",
            });
          }
        })
        .catch(() => {
          toast.error("Some thing went wrong with the slot validation.", {
            autoClose: 12000,
            position: "top-center",
          });
          this.setState({ loading: false });
        });
    } else {
      if (type === "parkingStalls") {
        onSetSuiteFormData({ parkingStalls: newValue });
      } else {
        onSetSuiteFormData({ storageLockers: newValue });
      }
    }
  };

  onAddPair = () => {
    const { onSetSuiteFormData, suiteFormData } = this.props;
    const suiteKeysAndValues = suiteFormData.suiteKeysAndValues ? suiteFormData.suiteKeysAndValues : [];    
    onSetSuiteFormData({
      suiteKeysAndValues: [...suiteKeysAndValues, {
        id: generateRandomNumber(),
        key: '',
        value: ''
      }]
    });
  }

  onRemovePair = (item) => {
    const { onSetSuiteFormData, suiteFormData } = this.props;
    const suiteKeysAndValues = suiteFormData.suiteKeysAndValues ? suiteFormData.suiteKeysAndValues : [];
    let updatedData = suiteKeysAndValues.filter(object => object.id !== item.id)
    onSetSuiteFormData({
      suiteKeysAndValues: updatedData
    })
  }

  onInputChange = (value, item, property) => {
    const { onSetSuiteFormData, suiteFormData } = this.props;
    let suiteKeysAndValues = suiteFormData.suiteKeysAndValues;
    let updatedData = suiteKeysAndValues.map(object => {
      if (object.id === item.id) {
        return { ...item, [property]: value };
      }
      return object;
    })
    onSetSuiteFormData({
      suiteKeysAndValues: updatedData
    })
  }

  render() {
    const {
      onClose,
      onSetSuiteFormData,
      suiteFormData,
      loader,
      propertySuites,
      buildingList,
      levelList,
      suiteStatuses
    } = this.props;
   const suiteKeysAndValues = suiteFormData.suiteKeysAndValues && suiteFormData.suiteKeysAndValues.length > 0 ? suiteFormData.suiteKeysAndValues : [];
    console.log('=====DEPLOYMENT CHECKING===');
    
   return (
      <Form
        headline={
          (suiteFormData && suiteFormData.id ? "Edit" : "Add") +
          " " +
          variables.Suite
        }
        onClose={onClose}
        actions={
          <>
            {loader || this.state.loading ? <Loader center={true} /> : null}
            <div />

            {suiteFormData && suiteFormData.id ? (
              <div />
            ) : (
                <Button
                  color="teal"
                  size="small"
                  label="Copy from Existing"
                  onClick={() => this.getPropertySuites()}
                />
              )}
            {suiteFormData && suiteFormData.id ? (
              <div />
            ) : (
                <Button
                  color="semantics"
                  size="small"
                  label="Save and Add Another"
                  disabled={
                    (suiteFormData && suiteFormData.number
                      ? !suiteFormData.number.trim()
                      : !suiteFormData.number) ||
                    (this.state.show ? !suiteFormData.fromUnitId : false) ||
                    !this.state.areas.length || suiteFormData.statusId === "00000000-0000-0000-0000-000000000000"
                  }
                  onClick={() => this.onSave(suiteFormData, "SaveAndAdd")}
                />
              )}

            <Button
              color="teal"
              size="small"
              label={"Save " + variables.Suite}
              disabled={
                (suiteFormData && suiteFormData.number
                  ? !suiteFormData.number.trim()
                  : !suiteFormData.number) ||
                (this.state.show ? !suiteFormData.fromUnitId : false) ||
                !this.state.areas.length || suiteFormData.statusId === "00000000-0000-0000-0000-000000000000"
              }
              onClick={() => this.onSave(suiteFormData, "SaveAndClose")}
            />
          </>
        }
        component={
          <>
            <h2 style={{ marginTop: '5%' }}>{`${variables.Suite} Details`}</h2>
            <Row>
              <Col xs="12" md="6">
                <Input
                  value={suiteFormData.number ? suiteFormData.number : ""}
                  onChange={(e) =>
                    onSetSuiteFormData({ number: e.target.value })
                  }
                  label={
                    variables.Suite === "Suite"
                      ? variables.Suite + " Number :"
                      : variables.Suite + ""
                  }
                  placeholder={
                    variables.Suite === "Suite"
                      ? variables.Suite + " Number"
                      : variables.Suite + ""
                  }
                  block
                  required={true}
                  disabled={checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name)}
                />
              </Col>
              <Col xs="12" md="6">
                <Input
                  value={
                    suiteFormData.warrantyAddress
                      ? suiteFormData.warrantyAddress
                      : ""
                  }
                  onChange={(e) =>
                    onSetSuiteFormData({ warrantyAddress: e.target.value })
                  }
                  label="Warranty/Civic Address :"
                  placeholder="Warranty/Civic Address"
                  block
                />
              </Col>
            </Row>
            <Row>
              <Col xs="6" md="6">
                <Select
                  value={suiteFormData.statusId !== "00000000-0000-0000-0000-000000000000" ? suiteFormData.statusId : ""}
                  onChange={(e) => this.handleSelectedStatus(e)}
                  options={suiteStatuses.map((status) => ({
                    value: status.id,
                    label: status.name,
                  }))}
                  label="Status"
                  placeholder="(Select status)"
                  disabled={checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name)}
                  block
                />
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="12">
                <File
                  label="Floorplan"
                  description="Upload photos (JPG or PNG or PDF)."
                  onSelect={(file) => onCheckExtensionDocument(file) && this.onValidateFile(file)}
                  files={
                    this.state.floorImage === suiteFormData.floorPlanURL
                      ? [] 
                      : !!suiteFormData.floorPlanURL && suiteFormData.floorPlanURL.length >0 && !suiteFormData.floorPlanURL[0].path.includes('.pdf')
                        ? suiteFormData.floorPlanURL
                        : []
                  }
                  image={this.state.floorImage && this.state.floorImage.includes('.pdf') ? null :  this.state.floorImage}
                  errors={this.state.errors.floorPlanURL}
                 
                />
                {this.state.floorImage && this.state.floorImage.includes('.pdf') &&
                  <a href={this.state.floorImage} target='_blank'>{this.state.floorImage.split('.com/')[1]}</a>}
              </Col>
            </Row>
           

            {this.state.show ? (
              <Select
                value={suiteFormData.fromUnitId ? suiteFormData.fromUnitId : ""}
                onChange={(e) => this.handleSelectedSuite(e)}
                options={propertySuites.map((suite) => ({
                  value: suite.id,
                  label: suite.number,
                }))}
                label="Copy from Existing"
                placeholder={`(Select ${variables.Suite})`}
                block
              />
            ) : null}
            <h2 style={{ marginTop: '2%' }}>Property Details</h2>
            <Row>
              <Col xs="12" md="6">
                <Input
                  value={suiteFormData.stratalot ? suiteFormData.stratalot : ""}
                  onChange={(e) =>
                    onSetSuiteFormData({ stratalot: e.target.value })
                  }
                  label="Strata Lot :"
                  placeholder="Strata Lot"
                  block
                  disabled={checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name)}
                />
              </Col>
              <Col xs="12" md="6">
                <Input
                  value={
                    this.state.isChanged
                      ? suiteFormData.buildingName
                      : suiteFormData.building && suiteFormData.building.id
                        ? suiteFormData.building.name
                        : suiteFormData.buildingId
                          ? suiteFormData.buildingName
                          : suiteFormData.buildingName
                  }
                  onChange={(e) => {
                    onSetSuiteFormData({
                      buildingName: e.target.value,
                      Building: e.target.value,
                      BuildingId: null,
                    });
                    this.setState({
                      displayBuildingItem: true,
                      isChanged: true,
                      buildingSearch: e.target.value,
                    });
                  }}
                  label="Buildings :"
                  placeholder="Start typing the Building's name to choose one"
                  block
                  disabled={checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name)}
                />
                {this.state.displayBuildingItem ? (
                  <Col>
                    {this.state.buildingSearch
                      ? buildingList
                        .filter(
                          ({ building }) =>
                            building
                              .toLowerCase()
                              .indexOf(this.state.buildingSearch.toLowerCase()) >
                            -1
                        )
                        .map((value, i) => {
                          return (
                            <div
                              onClick={() => this.onChangeBuilding(value)}
                              className="input__autoComplete"
                              key={i}
                            >
                              <span>{value.building}</span>
                            </div>
                          );
                        })
                      : null}
                  </Col>
                ) : null}
              </Col>
              <Col xs="12" md="6">
                <Input
                  value={
                    this.state.isLevelChanged
                      ? suiteFormData.levelName
                      : suiteFormData.level && suiteFormData.level.id
                        ? suiteFormData.level.name
                        : suiteFormData.levelId
                          ? suiteFormData.levelName
                          : suiteFormData.levelName
                  }
                  onChange={(e) => {
                    onSetSuiteFormData({
                      levelName: e.target.value,
                      Level: e.target.value,
                      LevelId: null,
                    });
                    this.setState({
                      displayLevelItem: true,
                      isLevelChanged: true,
                      levelSearch: e.target.value,
                    });
                  }}
                  label="Level :"
                  placeholder="Start typing the Level's name to choose one"
                  block
                />
                {this.state.displayLevelItem ? (
                  <Col>
                    {this.state.levelSearch
                      ? levelList
                        .filter(
                          ({ level }) =>
                            level &&
                            level
                              .toLowerCase()
                              .indexOf(this.state.levelSearch.toLowerCase()) > -1
                        )
                        .map((value, i) => {
                          return (
                            <div
                              onClick={() => this.onChangeLevel(value)}
                              className="input__autoComplete"
                              key={i}
                            >
                              <span>{value.level}</span>
                            </div>
                          );
                        })
                      : null}
                  </Col>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="6">
                <Row>
                  <div style={{ marginLeft: 16, marginTop: 10 }}>
                    <label className="file__label">Parking Stalls :</label>
                  </div>
                </Row>
                <div>
                  <CreatableSelect
                    placeholder="Enter Parking Stall"
                    isClearable
                    isMulti
                    value={
                      suiteFormData.parkingStalls ? suiteFormData.parkingStalls : []
                    }
                    onChange={(newValue, actionMeta) =>
                      this.onCheckExistingParkingStallStorageLockers(
                        newValue,
                        actionMeta,
                        "parkingStalls"
                      )
                    }
                    isDisabled={checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name)}
                  />
                </div>
              </Col>
              <Col xs="12" md="6">
                <Row>
                  <div style={{ marginLeft: 16, marginTop: 10 }}>
                    <label className="file__label">Storage Lockers :</label>
                  </div>
                </Row>
                <div style={{ marginBottom: 10 }}>
                  <CreatableSelect
                    placeholder="Enter Storage Locker"
                    isClearable
                    isMulti
                    value={
                      suiteFormData.storageLockers
                        ? suiteFormData.storageLockers
                        : []
                    }
                    onChange={(newValue, actionMeta) =>
                      this.onCheckExistingParkingStallStorageLockers(
                        newValue,
                        actionMeta,
                        "storageLockers"
                      )
                    }
                    isDisabled={checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name)}
                  />
                </div>
              </Col>
              <Col xs="12" md="6">
                <Row>
                  <div style={{ marginLeft: 16, marginTop: 10 }}>
                    <label className="file__label">Key Fobs Assignment :</label>
                  </div>
                </Row>
                <div>
                  <CreatableSelect
                    value={suiteFormData.keyFobs ? suiteFormData.keyFobs : []}
                    onChange={(e) =>
                      onSetSuiteFormData({ keyFobs: e })
                    }
                    isClearable
                    isMulti
                  />
                </div>
              </Col>

              <Col xs="12" md="6" style={{ marginTop: 10 }}>
                <Input
                  value={
                    suiteFormData.numberOfKeys ? suiteFormData.numberOfKeys : ""
                  }
                  onChange={(e) => onSetSuiteFormData({ numberOfKeys: e.target.value })}
                  label="Number of Physical Keys :"
                  block
                />
              </Col>
            </Row>
            {/**
             * Created By: Sai Prasad
             * Created Date: 07-11-2022
             * Jira Ticket: JUN-3352
             * Description: Key value pairs integration.
             */}
            <OtherDetails 
              keyValuePairs={suiteKeysAndValues}
              onInputChange={this.onInputChange}
              onAddPair={this.onAddPair}
              onRemovePair={this.onRemovePair}
            />

            <Row style={{ marginTop: '5px' }}>
              <Col xs="12" md="12">
                <div className="input">
                  <div className="input__require">
                    <label className="input__label">
                      Key Pickup Instructions :
                </label>
                  </div>

                  <div
                    class
                    style={{ borderBottom: "0.1rem solid rgba(83, 83, 83, 0.25)" }}
                    className="input__control"
                  >
                    <TextEditor
                      editorState={this.state.editorState}
                      onEditorStateChange={this.onEditorChange}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <h2 style={{ marginTop: '2%' }}>Warranty Details</h2>
            <Row>
              <Col xs="12" md="6">
                <Picker
                  label="Asset Warranty Default Start Date"
                  placeholderText="Choose Date"
                  showPopperArrow={false}
                  selected={
                    suiteFormData && suiteFormData.assetWarrantyDefaultStartDate
                      ? new Date(serviceRequestTableLocalTime(suiteFormData.assetWarrantyDefaultStartDate, 'suiteform'))
                      : null
                  }
                  onChange={(date) => {
                    onSetSuiteFormData({ assetWarrantyDefaultStartDate: date });
                  }}
                />
              </Col>
              <Col xs="12" md="6">
                <Input
                  value={
                    suiteFormData.warrantyNumber ? suiteFormData.warrantyNumber : ""
                  }
                  onChange={(e) =>
                    onSetSuiteFormData({ warrantyNumber: e.target.value })
                  }
                  label="Warranty Number :"
                  placeholder="Warranty Number"
                  block
                />
              </Col>
            </Row>

            <Row>
              <div style={{ marginLeft: 10 }}>
                <label className="file__label">
                  <h2> {"Rooms/Areas in " + variables.Suite}<span style={{ color: 'red', marginLeft: '2px' }}>*</span></h2>
                </label>
              </div>
            </Row>
            <Row>
              {this.state.suiteAreas.map((sAreas, i) => {
                let value = this.state.areas.find(
                  (data) => data.id === sAreas.id
                );

                return (
                  <Col xs="12" md="6">
                    <SuiteAreas
                      label={sAreas.name}
                      type="checkbox"
                      id={sAreas.id}
                      value={value && value.id ? value.id : null}
                      textValue={
                        value && value.customLabel ? value.customLabel : ""
                      }
                      disabled={!checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name) && value ? false : true}
                      onInputChange={(e) =>
                        this.onEnterText(e.target.value, sAreas.id)
                      }
                      onChange={(e) =>
                        this.handleAreas(e.target.id, value, sAreas)
                      }
                      isSpark={checkSparkDataAvailable(suiteFormData, this.props.user.roles[0].role.name)}
                      onAddArea={() => this.onAddArea(sAreas.id)}
                    />
                  </Col>
                );
              })}
            </Row>
          </>}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  suiteFormData: selectSuiteFormData(state),
  propertySuites: selectSuites(state),
  homeOwners: selectHomeOwners(state),
  suiteAreas: selectSuiteAreas(state),
  contacts: selectContacts(state),
  validation: selectValidation(state),
  loader: selectFormLoader(state),
  user: selectAuthenticatedUser(state),
  buildingList: state.buildings,
  levelList: state.levels,
  suiteStatuses: state.suiteStatuses
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onfetchAssetsBySuiteId: fetchAssetsBySuiteId,
      onFetchSuiteCounts: fetchSuiteCounts,

      onFetchPropertySuites: fetchPropertySuites,
      onStopFormLoading: stopFormLoading,
      onSetSuiteFormData: setSuiteFormData,
      clearSuiteFormData,
      fetchSuiteAreas,
      clearValidation: clearValidation,
      getBuildingLevels: getBuildingLevels,
      getSuiteStatuses: getSuiteStatuses,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SuiteForm);